export const FACILITIES_PROJECTS_ACTIONS = {
  FACILITIES_PROJECTS_PAGE_LOADED: 'FACILITIES_PROJECTS_PAGE_LOADED',
};
